import _ from 'lodash'
import calendars from 'scoreboard/components/calendars'
import Relative from 'scoreboard/components/relative-options'
import prettyId from './pretty-id'
import prettyRangeMultichoice from './pretty-range-multichoice'
import prettyRangeNumeric from './pretty-range-numeric'
import prettySet from './pretty-set'
import prettyTrend from './pretty-trend'
import prettyAncestor from './pretty-ancestor'
import prettyBoolean from './pretty-boolean'
import filterText from 'scoreboard/datasets/filters/filter-text'
import deletedValue from 'scoreboard/reports/common/deleted-value.hbs'
import { valuesText } from 'scoreboard/datasets/filters/filter-text'
import momentHelper from 'scoreboard/components/moment-helper'
import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER, TEXT, DATE } = DataType

// The salon is an object that returns a function that beautifies the filters
var salon = {
	'id': prettyId,
	'range-multichoice': prettyRangeMultichoice,
	'numeric': (filter) => filterText(null, filter, { dataType: NUMBER }),
	'range-numeric': prettyRangeNumeric,
	'set': prettySet,
	'text': (filter) => filterText(null, filter, { dataType: TEXT }),
	'trend': prettyTrend,
	'ancestor': prettyAncestor,
	'org': prettyAncestor,
	'boolean': prettyBoolean,
	'date': function(filter) {
		return filterText(null, filter, {dataType: DATE})
	}
}

// Helper methods to render filters as descriptive text
var PrettyHelper = {

	//Returns the descriptive text of a filter's values
	prettify: function(meta, filter, key) {
		return salon[meta.filterType].call(this, filter, meta, key)
	},

	//Returns an array of calendar labels based on the ids (if non relative reference)
	//or the distance from the current period (if relative)
	periodLabels: function(filterWithDateRange) {
		let {range, dateTimeOperator, periodIds, appliesToDates} = filterWithDateRange
		let multipleCode = 'datasets.filters.pretty.date.inAny'
		let singleCode = `${multipleCode}.singular`

		if (dateTimeOperator == 'today') {
			return []
		} else if (dateTimeOperator == 'on-any-date') {
			let dateLabels = _.map(appliesToDates, date => momentHelper.formatDate(date))
			return [valuesText(singleCode, multipleCode, dateLabels)]
		} else if (dateTimeOperator == 'in-any-period') {
			let periodLabels = _.map(periodIds, pid => calendars.periodsById[pid].label)
			return [valuesText(singleCode, multipleCode, periodLabels)]
		} else {
			var arr = _.values(_.pick(range,'first','last'))
			if (!range.relative) {
				return _.map(arr, function(v) {
					if (calendars.periodsById[v]) {
						return calendars.periodsById[v].label
					}
					return deletedValue()
				})
			}
			if (dateTimeOperator == 'between-date-time') {
				return [Relative.prototype.label(arr[0]), Relative.prototype.label(arr[1])]
			}
			return [Relative.prototype.label(arr[0])]
		}
	}
}

export default PrettyHelper

PrettyHelper.__filename__ = 'reports/common/filter/pretty-helper.js'
